import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BillingScheduledEditComponent } from './billing-scheduled-edit.component';
import { ReactiveFormsModule } from '@angular/forms';
import { BillingScheduleService } from './billing-schedule.service';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  declarations: [BillingScheduledEditComponent],
  exports: [BillingScheduledEditComponent],
  providers: [BillingScheduleService]
})
export class BillingScheduledEditModule { }



// WEBPACK FOOTER //
// ./src/app/utils/billing-scheduled-edit/billing-scheduled-edit.module.ts